/**
 * Ensures a URL is absolute so anchors don't resolve against the current
 * route. Links such as "www.hse.ie/diabetes" lack a protocol and would
 * otherwise be treated as relative paths.
 */
export const ensureAbsoluteUrl = (url) => {
  if (!url) {
    return url;
  }

  const hasProtocol = /^[a-z][a-z\d+\-.]*:\/\//i.test(url);

  return hasProtocol ? url : `https://${url}`;
};
